<!-- 灵活用工合伙人申请通道 (废弃)-->
<template>
  <div>
    <h1 style="margin-top: 30px;">灵活用工合伙人申请</h1>

    <van-form @submit="onSubmit" style="margin-top: 50px;" colon :show-error-message="false">
      <van-field v-model="parms.partnerName" name="partnerName" label="姓名" placeholder="请输入姓名"
        :rules="[{ required: true, message: '请输入姓名' }]" />
      <van-field v-model="parms.mobile" name="mobile" type="tel" label="电话" placeholder="请输入电话"
        :rules="[{ pattern, message: '请输入电话' }]" />
      <van-field v-model="parms.job" name="job" label="职务" placeholder="请输入职务，可填无"
        :rules="[{ required: true, message: '请输入职务，可填无' }]" />
      <van-field v-model="parms.referrerName" name="referrerName" label="推荐人姓名" placeholder="您通过哪位好友看到的推荐"
        :rules="[{ required: true, message: '您通过哪位好友看到的推荐' }]" />
        <van-field v-model="parms.referrerWechatAccount" name="referrerWechatAccount" label="推荐人微信号" placeholder="您通过哪位好友看到的推荐"
        :rules="[{ required: true, message: '您通过哪位好友看到的推荐' }]" />

      <div style="margin: 16px; margin-top: 40px;">
        <van-button round block type="info" native-type="submit">提 交</van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import http from '../../api/index.js'
import config from '../../utils/config.js'

export default {
  data() {
    return {
      parms: {
        partnerName: '',
        mobile: '',
        job: '',
        referrerName: '',
        referrerWechatAccount: '',
      },
      pattern: /^1\d{10}$/,
    };
  },
  components: {},

  created() {},

  mounted() {},

  methods: {
    onSubmit(values) {
      // console.log('submit', values);
      http.post('https://collect.htangcloud.com/collect-admin/partner/info/addPartnerInfo', this.parms).then((value) => {
        if (value.code == 0) {
          this.$toast.success('信息提交成功');
        }else{
          this.$toast.fail(value.message);
        }
      })
    },
  },
}

</script>

<style scoped>
/* @import url(); */
</style>


// WEBPACK FOOTER //
// src/pages/partner/applyInfo.vue